module.exports = __webpack_public_path__ + "static/img/cxgl.30911817.png";